import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { ModalTitle as CoreModalTitle } from '@vds-core/modals';
import { TypographyConfig, TitleConfig } from '@vds/typography';
var typescale = TypographyConfig.getTypescale();

var ModalTitle = function ModalTitle(props) {
  function _calcTypography(titleConfig, viewport) {
    return titleConfig.getStyles(typescale, viewport, 'large');
  }

  return /*#__PURE__*/React.createElement(CoreModalTitle, _extends({}, props, {
    typescale: typescale,
    titleConfig: TitleConfig,
    calcTypography: _calcTypography,
    padding: "0px",
    rightPadding: true
  }));
};

export default ModalTitle;